module.exports = function(video) {
	'use strict'
	video.directive('allVideosDir',allVideosDir);
	allVideosDir.$inject=[];
	function allVideosDir() {
		return {
			restrict: 'E',
			template: require('./partial/allvideos.html'),
			controller:'allVideosController',
			controllerAs:'vmav',
			link: function(scope, element, attrs, ctrl) {
				
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video/js/directive/allVideosDirective.js
// module id = 660
// module chunks = 0